import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <section id="download" className="section-padding download-hero">
        <Container>
          <div className="text-center" data-aos="zoom-in">
            <h2>
              Ready to Dive Deeper?
            </h2>
            <p>
              Download ZDIVE today and enhance your diving experience with detailed dive logging and analysis
            </p>
            <div className="download-buttons">
              <a 
                href="https://apps.apple.com/us/app/zdive/id6742788878" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="download-btn"
                aria-label="Download ZDIVE on the App Store"
              >
                <img 
                  src={`${process.env.PUBLIC_URL}/download-on-appstore.svg`} 
                  alt="Download ZDIVE on the App Store" 
                  className="app-store-badge"
                />
              </a>
            </div>
          </div>
        </Container>
      </section>

      <footer className="footer-custom">
        <Container>
          <Row>
            <Col lg={4} md={6} className="mb-4">
              <h5 className="footer-logo">
                <img
                  src={`${process.env.PUBLIC_URL}/wtrnsprnt200.png`}
                  alt="ZDIVE Logo"
                  className="footer-logo-img"
                />
                <span className="footer-logo-text">
                  <span className="footer-logo-z">Z</span>
                  <span className="footer-logo-dive">DIVE</span>
                </span>
              </h5>
              <p className="footer-description">
                Professional dive logging and analysis for iOS and watchOS. Enhance your diving experience with
                detailed post-dive analysis and comprehensive dive tracking. Always use a certified dive computer.
              </p>
              <div className="social-icons">
                <a 
                  href="https://x.com/ZDiveapp" 
                  className="social-icon" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="ZDIVE on X (formerly Twitter)"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a 
                  href="https://www.instagram.com/zdiveapp/" 
                  className="social-icon" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="ZDIVE on Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a 
                  href="mailto:dive@zyork.dev" 
                  className="social-icon"
                  aria-label="Contact ZDIVE Support Email"
                >
                  <i className="fas fa-envelope"></i>
                </a>
              </div>
            </Col>
            <Col lg={2} md={6} className="mb-4">
              <h5>Product</h5>
              <ul>
                <li><a href="#features">Features</a></li>
                <li><a href="#watch">Watch App</a></li>
                <li><a href="#ios">iOS App</a></li>
                <li><a href="#planning">Planning Tools</a></li>
                <li><a href="#breathing-exercises">Breathing</a></li>
                <li><a href="#safety">Safety</a></li>
              </ul>
            </Col>
            <Col lg={2} md={6} className="mb-4">
              <h5>Support</h5>
              <ul>
                <li><a href="#safety">FAQ</a></li>
                <li><a href="mailto:dive@zyork.dev">Contact Support</a></li>
                <li><a href="https://apps.apple.com/us/app/zdive/id6742788878" target="_blank" rel="noopener noreferrer">App Store</a></li>
                <li><a href="#watch">System Specs</a></li>
              </ul>
            </Col>
            <Col lg={2} md={6} className="mb-4">
              <h5>Company</h5>
              <ul>
                <li><a href="https://zyork.dev" target="_blank" rel="noopener noreferrer">ZYork Software</a></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-of-service">Terms of Service</Link></li>
                <li><a href={`${process.env.PUBLIC_URL}/llms.txt`} target="_blank" rel="noopener noreferrer">LLM Specs</a></li>
              </ul>
            </Col>
            <Col lg={2} md={6} className="mb-4">
              <h5>Connect</h5>
              <ul>
                <li><a href="https://x.com/ZDiveapp" target="_blank" rel="noopener noreferrer">Twitter / X</a></li>
                <li><a href="https://www.instagram.com/zdiveapp/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                <li><a href="mailto:dive@zyork.dev?subject=Partnership%20Inquiry">Partnerships</a></li>
                <li><a href="mailto:dive@zyork.dev?subject=ZDIVE%20Feedback">Feedback</a></li>
              </ul>
            </Col>
          </Row>
          <hr className="footer-divider" />
          <Row>
            <Col lg={6} className="text-center text-lg-start mb-2 mb-lg-0">
              <p className="footer-copyright">
                © {currentYear} ZDIVE · A product of ZYork Software LLC
                <br />
                <span className="footer-copyright-small">All rights reserved.</span>
              </p>
            </Col>
            <Col lg={6} className="text-center text-lg-end">
              <p className="footer-copyright">
                Made with <i className="fas fa-heart footer-heart"></i> for divers worldwide
              </p>
            </Col>
          </Row>
          <div className="text-center mt-3">
            <p className="footer-disclaimer">
              <i className="fas fa-exclamation-triangle footer-disclaimer-icon"></i>
              ZDIVE is designed for recreational use. Always dive within your certification limits and use certified equipment.
            </p>
          </div>
        </Container>
      </footer>
    </>
  );
}

export default Footer;